import { NestAPI } from '@marketing-milk/frontend'
import { useEffect, useState } from 'react'

export interface SlackUser {
  id: string
  displayName: string
  pfp: string
}

export const useSlackUsers = () => {
  const [users, setUsers] = useState<SlackUser[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    const fetchSlackUsers = async () => {
      setIsLoading(true)
      setError(null)

      try {
        const response = await NestAPI.get('/slack/users')

        setUsers(response.data)
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Unknown error'))
        console.error('Error fetching Slack users:', err)
      } finally {
        setIsLoading(false)
      }
    }

    fetchSlackUsers()
  }, [])

  return { users, isLoading, error }
}
